<template>
    <div id="form-container" ref="formContainer">
        <div id="pgTitle" tabindex="-1"><h1>{{pageTitle}}</h1></div>

        <form-wizard :stepSize="stepSize"
                     :nextButtonText="buttons.next"
                     :backButtonText="buttons.back"
                     :finishButtonText="buttons.submit"
                     color="#003865"
                     @on-complete="onSubmit"
                     @on-change="switchTabs"
                     id="wizard">
            <span slot="title" tabindex="-1"/>

            <tab-content title="Personal"
                         :before-change="()=>validateStep('personal')"
                         :after-change="()=>scrollTo()">
                <Personal ref="personal" @on-validate="mergePartialModels" :renewal-application="renewalApplication" :profile="profile"/>
            </tab-content>
            <tab-content title="Employment"
                         :before-change="()=>validateStep('emp')"
                         :after-change="()=>scrollTo()">
                <EmploymentHistory ref="emp" @on-validate="mergePartialModels" :renewal-application="renewalApplication"/>
            </tab-content>
            <tab-content title="Affirmation"
                         :before-change="()=>validateStep('confirm')"
                         :after-change="()=>scrollTo()">
                <Signature ref="confirm" @on-validate="mergeCheck" :renewalApplication="renewalApplication"/>
            </tab-content>
            <button class="btn btn-primary" :disabled="isDisabled" slot="finish">Submit Application</button>
        </form-wizard>
    </div>
</template>

<script>
    import EmploymentHistory from "@/components/wizard/EmploymentHistory";
    import Personal from "@/components/wizard/Personal";
    import Signature from "@/components/wizard/Signature";
    import {commonOptions} from "@/mixins/commonOptions";
    import {buttons} from "@/mixins/constants"
    import axios from 'axios';
    import axiosRetry from 'axios-retry';
    import {toastService} from "@/mixins/toastService";

    axiosRetry(axios, { retries: 0,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        name: "RenewalApplication",
        components:{
            EmploymentHistory,
            Personal,
            Signature
        },
        mixins: [
            commonOptions,
            buttons,
            toastService
        ],
        data() {
            return{
                stepSize: 'sm',
                layout: '',
                isSubmitted: false,
                pageTitle: '',
                renewalApplication: {
                    firstName: null,
                    lastName: null,
                    middleName: null,
                    ssn: null,
                    dateOfBirth: null,
                    contact:{
                        email: null,
                        phone: null,
                        address:{
                            streetAddress: null,
                            city: null,
                            state: null,
                            postalCode: null,
                        },
                    },

                },
                isDisabled: false,
                profile: { }
            }
        },
        created() {
            document.title = 'Nurse Aide Renewal Application';
            this.pageTitle = document.title;
            this.loadDraft();

        },
        methods: {
            buttons: function(){
                return buttons;
            },
            onSubmit(){
                if(!this.isDisabled){
                    this.isDisabled = true;
                }
                this.sendToServer();
            },
            sendToServer(){
                axiosRetry(axios, {retries: 0});
                if(this.renewalApplication.employers){
                  for(let i = 0; i< this.renewalApplication.employers.length; i++){
                    this.renewalApplication.employers[i].facilityType = {code: this.renewalApplication.employers[i].facilityType}
                  }
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/renewal`, this.renewalApplication)
                    .then(response => {
                        axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/contact/`,  this.renewalApplication.contact)
                            .then(response => {
                                this.isSubmitted = true;
                                this.$router.push('/home');
                            })
                    }).catch(err => {
                        if(err.response.status===406){
                            toastService.showRootToast('Error','The application was rejected because you already have a pending application.', 'danger', this.$root);
                        }
                        else {
                            toastService.showRootToast('Error','The application has encountered an issue. Please DO NOT resubmit, return to the home page to continue', 'danger', this.$root);
                        }
                  this.isDisabled = false;
                    })
            },
            validateStep(name){
                var refToValidate = this.$refs[name];
                return refToValidate.validate();
            },
            mergePartialModels(model, isValid){
                if(isValid){
                    this.renewalApplication = Object.assign({}, this.renewalApplication, model);
                    if(this.renewalApplication.opts){
                        delete this.renewalApplication.opts;
                    }
                }
            },
            mergeCheck(model){
                this.isCheck = model['isCheck'];
            },
            scrollTo(){
                let elem = document.getElementById('wizard');
                elem.scrollIntoView();
            },
            focus(e){
                let elem = document.getElementsByClassName('card-header')[e+1];
                elem.focus();
            },
            switchTabs(prevIdx, nextIdx){
                var title = 'Welcome';
                switch(nextIdx){
                    case 0:
                        title = 'Personal Information';
                        break;
                    case 1:
                        title = 'Employment Information';
                        break;
                    case 2:
                        title = 'Affirmation';
                        break;
                    default:
                        title = 'Application';
                }
                document.title = title + ' - Nurse Aide Renewal Application - NAR';
                this.pageTitle = document.title;
                document.getElementById('pgTitle').focus();
            },
            removeTabFocus(){
                this.$nextTick(function(){
                    var steps = document.querySelectorAll("div[role='tab']");
                    steps.forEach(step => {
                        step.setAttribute("tabindex", "-1");
                    });
                    var steps2 = document.querySelectorAll('.wizard-nav-pills>li>a');
                    steps2.forEach(step => {
                        step.setAttribute("tabindex","-1");
                        step.setAttribute("aria-disabled", true);
                    })
                });
            },
            loadProfile(){
                axiosRetry(axios, {
                    retries: 3,
                    retryDelay: axiosRetry.exponentialDelay
                });
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
                    .then(response => {
                        this.profile = response.data;
                        this.renewalApplication = response.data;
                    });
            },
          loadDraft(){
              axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/draft`)
                  .then(response => {
                      this.renewalApplication = response.data;
                      this.renewalApplication.suppressFirstUpdates = true;
                      //this.employers = response.data.employers;

                  })
                  .catch(error=>{
                    if(error.response.status===404){
                      this.loadProfile();
                      this.renewalApplication.suppressFirstUpdates = false;
                    }
                  })
          }
        },
        updated: function(){
            this.removeTabFocus();
        },
        mounted(){
            this.removeTabFocus();
            this.scrollTo();
        }


    }
</script>

<style scoped>

</style>